import { IShowEditTooltip } from './types';
import { AT_SET_CARD_COLORS_SHOW_EDIT_TOOLTIP } from './constants';

export const showEditTooltipSetAction = (
    isShow: boolean,
): IShowEditTooltip => ({
    type: AT_SET_CARD_COLORS_SHOW_EDIT_TOOLTIP,
    isShow
});
